import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from '@material-ui/core';

class Classes extends Component {
    constructor() {
        super();
        this.state = {
            classAvailable : []
        }
    }

    componentDidMount() {
        if (this.props.courseData && this.props.courseData.classes) {
            let canJoinClass = [];
            canJoinClass = this.props.courseData.classes.filter((data) => data.canjoin == true)
            this.setState({ classAvailable : canJoinClass})
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.popupOpen}
                // onRequestClose={() => this.props.popupClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <DialogTitle id="confirmation-dialog-title">Available Class</DialogTitle>
                {this.props.classesLoader ?
                    <div style={{ flexDirection: "column", display: "flex", alignItems: "center", justifyContent: "center", height: "30vh" }}><CircularProgress size={50} thickness={3} style={{color : "#13a89e"}}/></div> :
                    <div>
                        {this.state.classAvailable.length ? this.state.classAvailable.map((data, index) => {
                            return <List key={index}>
                                <ListItem button style={{ cursor: "text" }}>
                                    <ListItemText key={index} primary={data.title} />
                                    
                                    {/* <Link style={{ textDecoration: "none" }} to={{ pathname: `/course/${this.props.courseData.secondName}`, state: { index: index, course: this.props.courseData, user: this.props.user } }}> */}
                                    <Button variant="contained" color="primary" style={{backgroundColor : "#13a89e"}} onClick={() => this.props.joinClass(data)} >Join</Button>
                                    {/* </Link>  */}
                                </ListItem>
                                <Divider />
                            </List>
                        })
                            : <ListItem>
                                <ListItemText>Sorry No Class Available </ListItemText>
                            </ListItem>
                        }
                        <Typography style={this.props.networkErrorInJoinClass ? { display: "block", color: 'red', fontSize: '15px', marginLeft : "2%" } : { display: "none" }}>* Due to connention lost the class is not succesfully joined, plz retry</Typography>
                <DialogActions>
                    <Button onClick={() => this.props.popupClose()} variant="outlined">
                        Close
                    </Button>
                </DialogActions>
                </div>}
            </Dialog>
        )
    }
}

export default Classes;


// WEBPACK FOOTER //
// ./src/container/Classes/classes.js